<template>
<div class="jumbotron">
  <loading :active.sync="loading"></loading>
  <div class="row">
    <div class="col">
      <h1 class="header-text">Order Summary</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-3 text-right">
      <h5>Coupon Name:</h5>
    </div>
    <div class="col-9">
      <h5>{{ name }}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-3 text-right">
      <h5>Monthly Budget:</h5>
    </div>
    <div class="col-9">
      <h5>${{ budget }}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-3 text-right">
      <h5>Details:</h5>
    </div>
    <div class="col-9">
      <p>{{ details }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-3 text-right">
      <h5>Fine Print:</h5>
    </div>
    <div class="col-9">
      <p>{{ legal }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h3>Payment Information</h3>
      <div id="dropin-container"></div>
      <!--
      <p>Card number: 4111 1111 1111 1111</p>
      <p>Expiry: 09/20</p>
      <p>CVV: 400</p>
      -->
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
        An error has occured please try again later.
      </b-alert>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col form-control">
      <input v-bind:class="{'is-invalid': agreedToTermsInvalid}" id="agree_terms" v-model="agreedToTerms" type="checkbox" required>
      <label for="agree_terms">I have read and understand the <router-link class="link" to="/terms" target="_blank">Conditions of Order</router-link><span class="red-text" v-if="!agreedToTerms">*</span></label>
    </div>
  </div>
  <div class="row needs-padding">
    <div class="col-6">
      <router-link tag="button"
                   to="/profile/business/advertising/coupons/legal"
                   class="btn btn-secondary cover-open-space">Back</router-link>
    </div>
    <div class="col-6">
      <button v-on:click="registerCoupon" class="btn btn-primary">Create Coupon</button>
    </div>
  </div>
  <div class="alert-wrapper">
    <b-alert variant="warning"
              dismissible
              :show="mustAgreeToTermsMessage"
              @dismissed="mustAgreeToTermsMessage=false">
      Must agree to <router-link class="link" to="/terms" target="_blank">Conditions of Order</router-link> before creating Coupon
    </b-alert>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      agreedToTerms: false,
      agreedToTermsInvalid: false,
      loading: false,
      mustAgreeToTermsMessage: false,
      showDismissibleAlert: false
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters('business', [
      'getBusinessId'
    ]),
    ...mapGetters('products', [
      'getCouponCategory',
      'getCouponName',
      'getCouponListPrice',
      'getCouponDiscountedPrice',
      'getCouponDetails',
      'getCouponFreeClicks',
      'getCouponBudgetedClicks',
      'getCouponBudget',
      'getCouponDefaultResponse',
      'getCouponExpiration',
      'getCouponCombosAllowed',
      'getCouponCustomerReuses'
    ]),
    name () {
      return this.getCouponName
    },
    budget () {
      return this.getCouponBudget
    },
    details () {
      return this.getCouponDetails
    },
    legal () {
      var expiration = this.getCouponExpiration
      var length
      switch (expiration) {
        case 2160:
          length = 'ninety (90) days'
          break
        case 2880:
          length = 'one hundred twenty (120) days'
          break
        case 4320:
          length = 'six (6) months'
          break
        case 8760:
          length = 'one (1) year'
          break
      }

      var combosAllowed = this.getCouponCombosAllowed
      var combos
      switch (combosAllowed) {
        case true:
          combos = 'Valid'
          break
        case false:
          combos = 'Not valid'
          break
      }

      var customerReuses = this.getCouponCustomerReuses
      var reuses
      switch (customerReuses) {
        case 1:
          reuses = 'One (1) coupon'
          break
        case 2:
          reuses = 'Two (2) coupons'
          break
        case -1:
          reuses = 'Any number of coupons'
          break
      }

      return `Promotion lasts for ${length} from date of coupon claiming.
 No purchase necessary to participate. ${combos} with other certificates, vouchers, or offers.
 ${reuses} can be redeemed per household.`
    }
  },
  methods: {
    ...mapActions('business', [
      'getBtToken'
    ]),
    ...mapActions('products', [
      'createCoupon',
      'getCoupons'
    ]),
    async registerCoupon () {
      if (!this.agreedToTerms) {
        this.agreedToTermsInvalid = true
        this.mustAgreeToTermsMessage = true
        return
      } else {
        this.agreedToTermsInvalid = false
      }

      this.loading = true
      var that = this
      this.instance.requestPaymentMethod(async (err, payload) => {
        if (err) {
          console.log(err)
          this.loading = false
          return
        }
        try {
          await that.createCoupon({ businessId: that.getBusinessId, paymentMethodNonce: payload.nonce })
          await that.getCoupons({ businessId: 'self' })
          that.loading = false
          // Redirect to overview page
          that.$router.push('/profile/business/advertising')
        } catch (error) {
          console.log(error)
          that.loading = false
          that.showDismissibleAlert = true
        }
      })
    },
    async showPayment () {
      try {
        var clientToken = await this.getBtToken()
        var instance = await window.braintree.dropin.create({
          authorization: clientToken,
          container: '#dropin-container'
        })
        this.instance = instance
      } catch (error) {
        console.log(error)
        this.showDismissibleAlert = true
      }
    }
  },
  async mounted () {
    this.loading = true
    await Promise.all([this.showPayment()])
    this.loading = false
  }
}

</script>

<style scoped>
.cover-open-space {
  width: 100% !important;
}

.header-text {
  font-size: 2rem;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.link {
  color: black;
  text-decoration: underline !important;
}

.link:hover {
  color: #748096;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/subnavItems/Checkout.vue